import * as React from 'react';
import BlogList from './blog/List';
import { RouteComponentProps } from '@reach/router';
import ErrorBoundary from './ErrorBoundary';
import RssFeedList from './rss-feed/List';

type HomeProps = RouteComponentProps<{}>;

function Home(props: HomeProps) {
  return (
    <div className="home">
      <ErrorBoundary>
        <BlogList />
      </ErrorBoundary>

      <ErrorBoundary>
        <RssFeedList title="IMSA" url="https://www.imsa.com/rss.xml" className="imsa" />
      </ErrorBoundary>

      <ErrorBoundary>
        <RssFeedList title="Autosport IMSA" url="https://www.autosport.com/rss/feed/imsa" className="autosport" />
      </ErrorBoundary>
    </div>
  );
}
export default Home;
